// extracted by mini-css-extract-plugin
export default {"imgContain":"Yz","content":"Zz","titleAndImage":"aA","title":"bA","text":"cA","rhodeTitle":"eA","shortHR":"fA","modal_root":"gA","x_mark":"hA","flavorStickModal":"iA","greenBox":"jA"};
    if(module.hot) {
      // 1711394578523
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  